import { Controller } from '@hotwired/stimulus'

import { withSummaryItems } from '../src/mixins/with_summary_items'

export default class extends Controller {
  static targets = ['totalUsers', 'totalOrganisations']

  connect () {
    withSummaryItems(this)
  }

  update ({ detail: { recordsTotal, totalOrganisations } }) {
    this.presentSummaryItemNumber(this.totalUsersTarget, recordsTotal)
    this.presentSummaryItemNumber(this.totalOrganisationsTarget, totalOrganisations)
  }
}
